"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _HBDivider = require("./HBDivider.styles");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var HBDivider = function HBDivider(_ref) {
  var children = _ref.children,
    _ref$dashed = _ref.dashed,
    dashed = _ref$dashed === void 0 ? false : _ref$dashed,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _colors["default"].neutral200 : _ref$color,
    _ref$margin = _ref.margin,
    margin = _ref$margin === void 0 ? '' : _ref$margin,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(_HBDivider.DividerContainer, {
    margin: margin,
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_HBDivider.Divider, {
    color: color,
    dashed: dashed
  }, children && /*#__PURE__*/_react["default"].createElement("span", null, children)));
};
var _default = exports["default"] = HBDivider;
//# sourceMappingURL=HBDivider.js.map